import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { OrderCenterForm, OrderCenterShow, ProfileCredit } from '@/components'
import { CreditSummaryCard, InfoCard } from './components'
import { OrderCenterTable } from '@/pages/order-center/components'

import { useParamsState } from '@/helpers'
import { DEFAULT_LIMIT_PAGE } from '@/constants'
import { useOrderCenterCreditList } from '@/services'

import { CreditOrderProps } from './credit-order.type'

export const CreditOrder = ({ profile }: CreditOrderProps) => {
  const { uuid } = useParams()

  const [profileCreditSelected, setProfileCreditSelected] = useState(false)

  const [filter, setFilter] = useParamsState({
    page: '1',
    limit: `${DEFAULT_LIMIT_PAGE}`,
    search: '',
    taxStatus: '',
    moscow: '',
    createdAtBefore: '',
    createdAtAfter: '',
    ordering: '',
    keyAccountManager: '',
  })

  const { data: dataCreditOrder, isLoading: isLoadingCreditOrder } =
    useOrderCenterCreditList(
      { ...filter, buyer_profile: profile?.uuid || '' },
      true,
    )

  const [queryParams, setQueryParams] = useParamsState({
    uuid: '',
    action: '',
  })

  const defaultProps = {
    filter,
    onEditRegister: (uuid: string) =>
      setQueryParams({
        uuid,
        action: 'form',
      }),
    onSetFilter: setFilter,
    onShowRegister: (uuid: string) =>
      setQueryParams({
        uuid,
        action: 'show',
      }),
    formattedFilter: {},
    onDeleteRegister: () => {},
  }

  return (
    <>
      <InfoCard
        profile={profile}
        onEdit={() => setProfileCreditSelected(true)}
      />

      <CreditSummaryCard profile={profile} />

      <OrderCenterTable
        {...defaultProps}
        data={dataCreditOrder?.data}
        isLoading={isLoadingCreditOrder}
        type="credit"
        excludeFilterKeys={['buyer_profile']}
      />

      <OrderCenterShow
        isOpen={queryParams.action === 'show'}
        onHandleOpen={() =>
          setQueryParams({ ...queryParams, action: '', uuid: '' })
        }
        saleOrderUuid={queryParams.uuid}
        type={'credit'}
      />

      <OrderCenterForm
        isOpen={queryParams.action === 'form'}
        onHandleOpen={() =>
          setQueryParams({ ...queryParams, action: '', uuid: '' })
        }
        saleOrderUuid={queryParams.uuid}
        type={'credit'}
      />

      <ProfileCredit
        isOpen={profileCreditSelected}
        onHandleOpen={() => setProfileCreditSelected(false)}
        buyerProfileUuid={uuid || ''}
        financeProfileData={profile?.financeProfile}
      />
    </>
  )
}
